/* eslint-disable @typescript-eslint/no-explicit-any */
export  const onRemoveFile = (args: any, setFiles, files) => {

  const element: any = args.filesData[0];

  setFiles(files.filter((elem: any) => {
    return !(elem?.hash === element?.rawFile.hash);
  }));
};